import React from 'react';
import DashboardUsersContainer from './DashboardUsersContainer';

const DashboardUsers = () => <DashboardUsersContainer />;

export default DashboardUsers;
